<section class="p-3 border-bottom-1 surface-border">
    <h5 class="m-0">Notificaciones</h5>
    <small class="text-color-secondary">Últimas notificaciones</small>
</section>

<ul class="list-none p-0 m-0 max-h-30rem overflow-y-auto" role="list">
    <li *ngFor="let notif of notificacionesLimitadas" role="listitem"
        class="p-3 border-bottom-1 surface-border border-round-sm transition-colors flex align-items-center gap-4"
        [ngClass]="{ 'bg-green-50 dark:!bg-green-900': !notif.leida }">

        <div class="w-10 h-10 rounded-full flex items-center justify-center text-white text-lg bg-primary">
            <i class="pi pi-file"></i>
        </div>

        <div class="flex-1 min-w-0">
            <div class="font-medium text-xs text-overflow-ellipsis white-space-nowrap overflow-hidden">
                {{ notif.titulo }}
            </div>
            <div class="text-base font-semibold text-color-secondary mt-1 text-overflow-ellipsis">
                {{ notif.mensaje }}
            </div>
            <div class="text-xs text-color-secondary mt-2">{{ notif.fecha | date:'short' }}</div>
        </div>

        <div>
            <button pButton icon="pi pi-check" class="p-button-text p-button-sm text-green-500"
                (click)="marcarComoLeida(notif)" [disabled]="notif.leida" aria-label="Marcar como leída">
            </button>
        </div>
    </li>
</ul>

<!-- vacío -->
@if (notificacionesLimitadas.length === 0){
<div class="p-3 text-center">
    <p class="m-0 text-color-secondary">No hay notificaciones</p>
</div>
}

<footer class="p-3 border-top-1 surface-border flex justify-content-center">
    <button pButton label="Ver todas" class="p-button-text p-button-sm" (click)="verTodas()">
    </button>
</footer>